// Approved course prices, not derived from regular per-lesson tuition rates.
export const PRACTICAL_COURSE = {
  durationHours: 4,
  currency: "SGD",
  fees: [
    { level: "O-Level", min: 240, max: 400 },
    { level: "H2 / A-Level", min: 420, max: 580 },
  ],
} as const;

export function formatCourseFee(fee: { min: number; max: number }): string {
  return `${PRACTICAL_COURSE.currency} ${fee.min}-${fee.max}`;
}

export const HOLIDAY_PROGRAMME = {
  year: 2026,
  bookingCondition:
    "Subject to availability and demand. We confirm your schedule, activities, materials and exact fee before booking. An enquiry does not reserve a place.",
  quoteCondition:
    "Lower-secondary and international programmes: ask for a quote.",
} as const;

export const CRASH_COURSE = {
  currentDates:
    "Enquire for current dates. We will confirm the subject, level, trainer and number of places before you make plans.",
  bookingCondition:
    "Send the student's level, subject and the skills they want to work on. We will confirm the date, trainer, class size, equipment provided, materials and total fee before you book.",
} as const;

export const IB_LAB_ACCESS = {
  confirmation:
    "A session is confirmed only after the method is accepted and the student's teacher has approved the investigation.",
  teacherApproval:
    "Yes. You may ask about feasibility while approval is pending, but Eclat will not confirm a laboratory session until the investigation has been approved by the student's school or teacher.",
  supervision:
    "No. This is supervised laboratory access, not unsupervised bench rental. Eclat confirms the supervision arrangement before accepting a request.",
  authorship:
    "No. The research question, method, data, analysis, evaluation, and writing must remain the student's own work. Eclat reviews whether the proposed use of the laboratory is feasible.",
  equipment:
    "Equipment is confirmed from the proposed method. Eclat does not promise a fixed inventory for every investigation, so send the full equipment and materials list before making plans.",
  storage:
    "Possibly, but only after case-by-case review. Storage, access, sample stability, waste, and supervision must be agreed before the investigation starts.",
  serviceScope:
    "No. Practical tuition teaches and rehearses laboratory skills. This service is for an IB student who already has a proposed IA or EE method and needs to ask whether the laboratory can support it.",
} as const;
